import { irrigacao } from './genericos'

const PRPD = {
  areaDestinada: '',
  dataInicio: '',
  grauDegradacao: '',
  hasAnaliseSolo: '',
  tecnicasUtilizadas: [],
  outrosTecnicasUtilizadas: '',
  utilizaBioinsumos: '',
  possuiIrrigacao: '',
  financiamentos: [],
  outroFinanciamento: '',
  descricao: '',
  bioinsumos: [],
  irrigacao: {...irrigacao}
}

export default PRPD



// WEBPACK FOOTER //
// ./src/libs/models/cadastro/praticas/PRPD.js